
// src/services/chatService.js
const FUNCTIONS_BASE_URL = process.env.REACT_APP_FUNCTIONS_URL || 
  'https://us-central1-arabic-ai-kids.cloudfunctions.net';

export const sendChatMessage = async (message, userId, conversationHistory = []) => {
  try {
    console.log('🤖 Sending chat message to:', `${FUNCTIONS_BASE_URL}/chatWithAI`);
    console.log('📤 Message:', message);
    console.log('👤 User ID:', userId);
    
    const response = await fetch(`${FUNCTIONS_BASE_URL}/chatWithAI`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        message,
        userId,
        conversationHistory
      }),
    });

    console.log('📡 Response status:', response.status);
    
    if (!response.ok) {
      const errorData = await response.json();
      console.error('❌ API Error:', errorData);
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('✅ Success:', result);
    return result;
  } catch (error) {
    console.error('💥 Chat Service Error:', error);
    throw error;
  }
};